/**
 * Normalize various stop/coordinate shapes into a { lat, lng } pair.
 * @param {any} value
 * @returns {{ lat: number, lng: number }|null}
 */
const toLatLng = (value) => {
  if (!value) return null;
  const lat = Number.parseFloat(
    value.lat ??
      value.latitude ??
      value.location?.lat ??
      value.location?.latitude ??
      value.coordinates?.[0] ??
      value[0],
  );
  const lng = Number.parseFloat(
    value.lng ??
      value.longitude ??
      value.location?.lng ??
      value.location?.longitude ??
      value.coordinates?.[1] ??
      value[1],
  );
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

export default toLatLng;
